export default __webpack_public_path__ + "assets/images/7384e28f7516d024322f96a5d6a5945a.svg";